export const F = {
  current: 'Σ (Selling Price − Inward B2B Price) × Qty ÷ Σ (Selling Price × Qty) × 100',
  outward: 'Σ (MRP − Selling Price) × Qty ÷ Σ (MRP × Qty) × 100',
  inward: 'Σ (MRP − Inward B2B Price) × Qty ÷ Σ (MRP × Qty) × 100',
  currentValue: 'Σ (Selling Price − Inward B2B Price) × Qty',
  outwardValue: 'Σ (MRP − Selling Price) × Qty',
  markup: '(MRP − Selling Price) ÷ Selling Price × 100',
  discount: '(MRP − Selling Price) ÷ MRP × 100, simple average of lines',
};

